module Meevo.Convo {
    export enum ConvoStatus {
        Resolved, Unresolved, NoAccess, ResolvedWithNoAction
    }

    export enum ConvoError {
        'NotEnabled' = 0,
        'NotAvailableInCO' = 1,
        'NotAvailable' = 2,
        'OnlyAvailableInCO' = 3,
        'NotAvailableInCallCenter' = 4
    }

    export interface AccessLevel {
        role?: Meevo.Model.SecurityAccessEnum;
        availabilityLevel?: Meevo.Model.SecurityAccessEnum;
        module?: Meevo.Model.SecurityAccessEnum;
        securityKeyPath?: string;
    }
}
